import React from 'react';
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import { padCalendar, numTo2DecimalsPercent, dollarFormatWithCommas } from "./../../../../util";
import styled from "styled-components";
import { Button } from "../../Button";
const ButtonHolder = styled.div`
	margin-top: 10px;
`;
const LeftSideButton = styled(Button)`
	float: right;
	margin-left: 18px;
	vertical-align: mid
`;

export const risksSelectorColumns = (risksOnClick, purchaseClick) => {

    let columns = [{
			title: "Company Name",
			name: "riskName",
			onClick: (risk) => risk.caseId && risksOnClick(risk),
			getClassName: (risk) => {
				const entryClass = "commission-selector-entry";
				return risk.caseId ? entryClass+'-clickable' : entryClass;
			},
			colNum: 1,
			sortyBy: 'riskName',
			textAlign: 'left',
			width: 250
		},
		{
			title: "Sector",
			name: "gicsSectorName",
			colNum: 2,
			className: 'commission-selector-entry',
			sortyBy: "gicsSectorName",
			width: 150
		},
		{
			title: "U.S. Exchange",
			name: "market",
			colNum: 2,
			className: 'commission-selector-entry',
			sortyBy: "market",
		},
		{
			title: "Ticker",
			name: "symbol",
			colNum: 3,
			className: 'commission-selector-entry',
			sortyBy: "symbol",
		},
		{
			title: "SAR Risk Score\u00AE",
			name: "riskScore",
			colNum: 4,
			className: 'commission-selector-entry',
			format: (riskScore) => numTo2DecimalsPercent(riskScore),
			sortyBy: "riskScore",
			width: 90
		},
		{
			title: "Market Cap",
			name: "mcap",
			colNum: 5,
			className: 'commission-selector-entry',
			format: (mcap) => dollarFormatWithCommas(mcap),
			sortyBy: "mcap",
			textAlign: 'right',
		},
		{
			title: "Risk Assessment Date",
			name: "classPeriodEnd",
			colNum: 6,
			className: 'commission-selector-entry',
			format: (classPeriodEnd) => padCalendar(classPeriodEnd),
			sortyBy: "classPeriodEnd",
			width: 150
		},
		{
			title: "",
			colNum: 7,
			noSort: true,
			className: 'commission-selector-entry',
			format: (risk) => <React.Fragment>
				<ButtonHolder>
						<LeftSideButton
							onClick={() => purchaseClick(risk)}
							hoverBorderColor="#83bed3"
							tabIndex="-1"
						>
							{risk.caseId? "View Risk Report" : "License Risk Report"}
						</LeftSideButton>
					</ButtonHolder>
			</React.Fragment>,
		}
	]

    return columns;
}


// WEBPACK FOOTER //
// ./src/common/components/TableGrid/tableColumn/RisksSelectorColumns.js